import React from 'react';
import type { FC } from 'react';
import isUnicodeSupported from 'is-unicode-supported';
import { Text } from '../components/Text.js';

interface Props {
  selected?: boolean;
}

export const RadioIcon: FC<Props> = ({ selected }) => {
  let content = isUnicodeSupported() ? '○' : 'o';
  if (selected) {
    content = isUnicodeSupported() ? '●' : '•';
  }
  return <Text>{content}</Text>;
};
